import { z } from 'zod';

/**
 * Shared schemas for the `/api/accounts/*` thin proxy routes.
 *
 * These mirror the `accounts.*` wire contract in `matcha-api`
 * (`src/schemas/accounts.ts` → `zMeOutput`). `accounts.bootstrap`,
 * `accounts.me`, and `accounts.updateProfile` all return the identical
 * `{ account, wallets[] }` payload, so the proxy validates upstream
 * responses against a single shape here rather than restating it per route.
 *
 * Timestamps are `z.string()` because Postgres `timestamptz` values serialize
 * to ISO strings over the tRPC HTTP surface — the same choice matcha-api makes.
 */
// Preserve Zod 3 UUID validation, which did not enforce version or variant bits.
const accountIdSchema = z.guid();

export const zAccount = z.object({
  id: accountIdSchema,
  privyUserId: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastSeenAt: z.string(),
});

export const zWallet = z.object({
  id: accountIdSchema,
  accountId: accountIdSchema,
  walletAddress: z.string(),
  chainType: z.enum(['ethereum', 'solana']),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zAccountsPayload = z.object({
  account: zAccount,
  wallets: z.array(zWallet),
});
